<template>
  <section class="section">
    <div class="container">
      <div class="columns">
        <div class="column is-4 is-offset-4">
          <h2 class="title has-text-centered">
            {{ $t('message.login_system') }}
          </h2>

          <b-notification
            :active="!!error"
            type="is-danger"
            aria-close-label="Close notification"
            role="alert"
          >
            {{ error }}
          </b-notification>

          <form-wrapper :validator="$v.form">
            <form @submit.prevent="login" novalidate>
              <form-group
                name="account"
                :messages="{ required: 'validation.required_account' }"
              >
                <b-input
                  v-model.trim="form.account"
                  @input="$v.form.account.$touch()"
                  name="account"
                  icon="account"
                  :placeholder="$t('message.please_input_account')"
                ></b-input>
              </form-group>

              <form-group name="password">
                <b-input
                  v-model.trim="form.password"
                  @input="$v.form.password.$touch()"
                  type="password"
                  name="password"
                  icon="key"
                  :placeholder="$t('message.please_input_password')"
                ></b-input>
              </form-group>

              <b-field>
                <p class="control">
                  <b-button
                    :loading="isLoading"
                    type="is-primary"
                    native-type="submit"
                    class="is-fullwidth"
                  >
                    {{ $t('message.login') }}
                  </b-button>
                </p>
              </b-field>
            </form>
          </form-wrapper>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'Login',

  data() {
    return {
      isLoading: false,
      error: null,
      form: {
        account: null,
        password: null
      }
    }
  },
  validations: {
    form: {
      account: { required },
      password: { required }
    }
  },
  mounted() {
    if (this.$auth.check()) {
      this.$router.push({ name: 'home' })
    }
  },
  methods: {
    async login() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      try {
        this.error = null
        this.isLoading = true
        await this.$auth.login(this.form)
      } catch (e) {
        this.error = '帳號密碼錯誤，請重新輸入'
        this.form.password = ''
        this.$v.form.password.$reset()
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>
